import { projectTypeWarrantiesAPI } from "@/views/ProjectTypeWarranties/services/api";

export const getProjectTypeWarranties = async () => {
  try {
    const res = await projectTypeWarrantiesAPI.getList();
    return res?.data;
  } catch (e) {}
};

export const updateProjectTypeWarranty = async (project_type_id, body = {}) => {
  try {
    const res = await projectTypeWarrantiesAPI.update(project_type_id, body);
    return res?.data;
  } catch (e) {}
};

export const projectTypeWarrantiesColumns = [
  {
    name: "project_type_id",
    field: "project_type_id",
    label: "ID",
    align: "center",
  },
  {
    name: "project_type_name",
    field: "project_type_name",
    label: "Тип проекта",
    align: "left",
  },
  {
    name: "warranty_contractor",
    field: "warranty_contractor",
    label: "Гарантия если материалы от подрядчика",
    align: "center",
  },
  {
    name: "warranty_team_project",
    field: "warranty_team_project",
    label: "Гарантия если материалы от команды проекта",
    align: "center",
  },
  { 
    name: "edit", 
    field: "edit", 
    label: "Действия", 
    align: "center" 
  },
];
